import React from 'react'

import { Suspense } from '~/components/elements/Suspense'
import { useSurveyForSettingsQuery } from '~/hooks/useSurveyForSettingsQuery'

import { SegmentDefinitions } from './components/SegmentDefinitions'

export const SegmentDefinitionsPage = () => {
  const { isLoading } = useSurveyForSettingsQuery()

  return (
    <Suspense loading={isLoading}>
      <SegmentDefinitions />
    </Suspense>
  )
}
